// src/utils/downloadFile.ts
/*
export const downloadFile = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
*/

/**
 * Triggers a browser download for a given Blob object.
 * @param blob The Blob data to download.
 * @param filename The desired name for the downloaded file.
 */
export const downloadFile = (blob: Blob, filename: string) => {
  // Create a new object URL for the blob
  const url = window.URL.createObjectURL(blob);

  // Create a temporary anchor element
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;

  // Append to the DOM, click, and then remove
  document.body.appendChild(a);
  a.click();
  a.remove();

  // Release the object URL
  window.URL.revokeObjectURL(url);
};
